// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8a61e526","498":"86e37c9f","703":"70aa5837"}[chunkId] + ".chunk.js";
};